import { createContext } from 'react'
import {
  type ReactReduxContextValue,
  createDispatchHook,
  type TypedUseSelectorHook,
  createSelectorHook,
} from 'react-redux'
import {
  TypedSunovationDispatch,
  TypedSunovationState,
} from './sunovationStore'

export const SunovationReduxContext = createContext<
  ReactReduxContextValue<TypedSunovationState>
>({} as any)
export const useTypedSunovationDispatch: () => TypedSunovationDispatch =
  createDispatchHook(SunovationReduxContext)

export const useTypedSunovationSelector: TypedUseSelectorHook<TypedSunovationState> =
  createSelectorHook(SunovationReduxContext)
